var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.stepsList[_vm.active].component,{ref:"components",tag:"components",staticClass:"component",attrs:{"renderData":_vm.renderData,"loading":_vm.loading},on:{"cancel":_vm.cancel,"previousStep":_vm.previousStep,"confirm":_vm.confirm,"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }